export const PIPELINES_INITIAL_PAGE_SIZE = 30;
export const PIPELINES_PAGE_SIZE = 50;
